import { axiosInstance } from "../../../axios/axiosInstance";
import { LANDING_API_URL, getDefaultHeaders } from "../../../config";

const authHeaders = (extra = {}) => {
  const authToken = localStorage.getItem("authToken");
  return {
    ...getDefaultHeaders(),
    Authorization: `Bearer ${authToken}`,
    ...extra,
  };
};

export const getOurValues = () =>
  axiosInstance.get(`${LANDING_API_URL}/our-values`, {
    headers: authHeaders(),
  });

export const createOurValueRequest = (formData) =>
  axiosInstance.post(`${LANDING_API_URL}/our-values`, formData, {
    headers: authHeaders({ "Content-Type": "multipart/form-data" }),
  });

export const updateOurValueRequest = (id, formData) =>
  axiosInstance.post(`${LANDING_API_URL}/our-values/${id}`, formData, {
    headers: authHeaders({ "Content-Type": "multipart/form-data" }),
  });

export const removeOurValue = (valueId) =>
  axiosInstance.delete(`${LANDING_API_URL}/our-values/${valueId}`, {
    headers: authHeaders(),
  });
